import { registerQuery } from 'data-fetching-client';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
function flattenMetadata({
  metadata
}) {
  return Object.fromEntries(Object.entries(metadata).map(([key, {
    value
  }]) => [key, value]));
}
export const GET_ENROLLABLE_OBJECT_TYPES_FAS = registerQuery({
  fieldName: 'formulaEditor_enrollableObjectTypesFAS',
  async fetcher() {
    const client = await getFrameworkDataSchemasClient();
    const results = await client.typeMetadata.get({
      appSettingNames: ['workflowsUsageOfCrmObjects']
    });
    return Object.fromEntries(Object.entries(results).map(([, {
      workflowsUsageOfCrmObjects
    }]) => {
      const flattenedMetadata = flattenMetadata(workflowsUsageOfCrmObjects);
      return [flattenedMetadata.objectTypeId, flattenedMetadata];
    }).filter(([, {
      isEnrollable
    }]) => isEnrollable));
  }
});